module.exports = __webpack_public_path__ + "img/system.ddf64aa8.png";